module.exports = __webpack_public_path__ + "img/gum2.68879b50.png";